import zombieTankDriver from '../../zombie-tank-driver.png';
import styles from './styles.module.css';

function MainBlock() {
  return (
    <div className={styles.container}>
        <img className={styles.heroImage} src={zombieTankDriver} />
        <div className={styles.textBlock}>
            <span className={styles.subHeading}>CURRENTLY RANK #1 ON MAGICEDEN</span>
            <h1 className={styles.heading}>Help Ukrainians to defend our country</h1>
            <span className={styles.paragraph}>A big collection of dead russian zombie soldiers that were eliminated with Ukrainian courage and strength.</span>
        </div>
    </div>
  );
}

export default MainBlock;
